import { graphql } from "../graphql";
import query from "./query.gql";
import { IRepoErrors } from "../errors";
import { FetchResult } from "@apollo/client";
import { graphqlExtractGraphqlErrors } from "@/v2/util/graphql-extract-graphql-errors";
import { graphqlRemapValidationErrors } from "@/v2/util/graphql-remap-validation-errors";
import {
  UserManagementUserAccessTypeEnum,
  UserManagementTenantRoleEnum,
} from "@/v2/enum/user-management";

export async function fetchInvites(
  organizationId: string
): Promise<Array<IFetchInvitesResponseItem>> {
  let response: FetchResult<any, Record<string, any>, Record<string, any>>;
  const errors: IRepoErrors<ValidationErrors> = {};

  try {
    response = await graphql.query({
      query,
      variables: {
        organizationId,
        first: 999,
        page: 1,
      },
    });
  } catch (error) {
    errors.networkError = true;
    throw new FetchInvitesError(errors);
  }

  if (response.errors) {
    errors.graphqlError = graphqlExtractGraphqlErrors(response);
    errors.validationError = graphqlRemapValidationErrors(response);
    throw new FetchInvitesError(errors);
  }

  return response.data.invites.data;
}

export class FetchInvitesError extends Error {
  errors: IRepoErrors<ValidationErrors>;

  constructor(errors: IRepoErrors<ValidationErrors>) {
    super("Error in repo: FetchInvites");
    this.errors = errors;
    this.name = this.constructor.name;
  }
}

type ValidationErrors = {};

interface IFetchInvitesResponseItem {
  id: string;
  email: string;
  role: UserManagementTenantRoleEnum;
  accessibleResources: IAccessibleResources;
}

interface IAccessibleResources {
  accessType: UserManagementUserAccessTypeEnum;
  accessIds: Array<string>;
}
